/*eslint eqeqeq: "off"*/
import * as React from 'react';
import { Link } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, makeStyles, hexToRgb } from '@mui/material/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { EditOutlined } from '@mui/icons-material';
import * as hmiclientbase from '../../hmilib/hmiclientbase';
import { CompactPicker, AlphaPicker, RGBColor } from 'react-color';

import Tabel, { IFilterItems } from '../../MainControl/Table/Tabel';

interface IDialogParams {
    id: number;
    namePoint: string;
    hexColor: string;
    typeLine: string;
    typeScale: string;
    callbackSave: any;
}

const DialogParams = (props: IDialogParams) => {
    const [open, setOpen] = React.useState(true);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme?.breakpoints.down('sm'));

    const [item, setItem] = React.useState('');

    const [param, setParam] = React.useState('');

    const typeLineArr = ['line', 'linePoint', 'point', 'step', 'areadiscrete'];
    const typeLineArrRus = ['Линия', 'Линия с точками', 'Точки', 'Дискретный', 'Дискретная заливка'];

    const typeScaleArr = ['auto', 'system', 'custom'];
    const typeScaleArrRus = ['автомасштаб', 'системный', 'пользовательский'];

    const [typeLine, setTypeLine] = React.useState('');
    const [typeScale, setTypeScale] = React.useState('');
    const [namePoint, setNamePoint] = React.useState('');

    const [openEditPath, setOpenEditPath] = React.useState(false);

    const [listitem, setListItem] = React.useState<string[]>();

    const [color, setColor] = React.useState<RGBColor>();
    const [colorOutType, setColorOutType] = React.useState('HEX');
    const [colorText, setColorText] = React.useState('');
    const [colorTextFocus, setColorTextFocus] = React.useState(false);
    React.useEffect(() => {
        if (!colorTextFocus) {
            let ct =
                colorOutType === 'HEX'
                    ? RGBAToHex(color)
                    : color !== undefined
                      ? `rgba(${color.r},${color.g},${color.b},${color.a})`
                      : '';
            setColorText(ct);
        }
    }, [color]);
    React.useEffect(() => {
        let ct =
            colorOutType === 'HEX'
                ? RGBAToHex(color)
                : color !== undefined
                  ? `rgba(${color.r},${color.g},${color.b},${color.a})`
                  : '';
        setColorText(ct);
    }, [colorOutType]);

    let itemtabledef = {
        items: [],
        filterItems: {
            path: {
                desc: 'Путь',
                filterList: new Map(),
                statusFilterSelect: false,
                typeFilter: 'InputNotA',
                sortFilter: { sortItem: [], sortCol: 'default', sortUp: false }
            },
            description: {
                desc: 'Описание',
                filterList: new Map(),
                statusFilterSelect: false,
                typeFilter: 'InputNotA',
                sortFilter: { sortItem: [], sortCol: 'default', sortUp: false }
            }
        },
        OptionsPage: {
            MaxPage: 0,
            SelectPage: 0,
            SizePage: 20
        },
        colList: ['path', 'description'],
        loding: false,
        setTime: {}
    };

    const [iditemsTable, setIdItemsTable] = React.useState<string[]>([]);

    const [pageitemsTable, setpageItemsTable] = React.useState<any>(itemtabledef);

    const [ItemSelectedIndex, setItemSelected] = React.useState<number>(-1);

    React.useEffect(() => {
        UpdteItemPage(0);
    }, [iditemsTable]);

    React.useEffect(() => {
        if (namePoint === '') {
            setNamePoint(props.namePoint);
        }
        if (typeLine === '') {
            setTypeLine(props.typeLine);
        }
        if (typeScale === '') {
            setTypeScale(props.typeScale);
        }
        if (color === undefined) {
            if (props.hexColor.indexOf('rgb') > -1) {
                setColor(rgbToRGBA(props.hexColor));
            } else {
                setColor(hexToRGBA(props.hexColor));
            }
        }

        updateItems();
    }, []);

    const rgbToRGBA = (rgbStr: string) => {
        let str = rgbStr.substring(rgbStr.indexOf('(') + 1, rgbStr.indexOf(')')).split(',');

        let rgbColor: RGBColor = { r: 0, g: 0, b: 0, a: 1 };

        rgbColor.r = +str[0];
        rgbColor.g = +str[1];
        rgbColor.b = +str[2];

        if (str[3] !== undefined) {
            rgbColor.a = +str[3];
        }

        return rgbColor;
    };

    const hexToRGBA = (hex: string): RGBColor => {
        if (hex.substring(0, 1) == '#') {
            hex = hex.substring(1);
        }

        let rgbColor: RGBColor = { r: 0, g: 0, b: 0, a: 1 };

        rgbColor.r = parseInt(hex.substring(0, 2), 16);
        rgbColor.g = parseInt(hex.substring(2, 4), 16);
        rgbColor.b = parseInt(hex.substring(4, 6), 16);
        if (hex.substring(6) !== '') {
            rgbColor.a = +(parseInt(hex.substring(6), 16) / 255).toFixed(2);
        }
        return rgbColor;
    };
    const RGBAToHex = (rgba: RGBColor | undefined): string => {
        if (rgba !== undefined) {
            let hex = '#';

            let alpha = rgba.a !== undefined ? Math.ceil(rgba.a * 255) : 255;
            let strAlpha = (alpha < 16 ? '0' : '') + alpha.toString(16);

            hex =
                hex +
                (rgba.r < 16 ? '0' : '') +
                rgba.r.toString(16) +
                (rgba.g < 16 ? '0' : '') +
                rgba.g.toString(16) +
                (rgba.b < 16 ? '0' : '') +
                rgba.b.toString(16) +
                strAlpha;

            return hex;
        } else {
            return '#000000';
        }
    };
    const parseColorStr = (str: string) => {
        setColorText(str);

        let hex_color_regex = '^#[0-9a-f]{3}([0-9a-f]{3})?([0-9a-f]{2})?$';
        let res = str.match(hex_color_regex);
        if (res !== null) {
            setColor(hexToRGBA(str));
        } else {
            let rgba_color_regex =
                '^rgba\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])%?\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])%?\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])%?\\s*,\\s*((0.[1-9])|[01])\\s*\\)$';
            res = str.match(rgba_color_regex);
            if (res !== null) {
                console.log(res);
                let c: RGBColor = {
                    r: Number(res[1]),
                    g: Number(res[2]),
                    b: Number(res[3]),
                    a: Number(res[4])
                };
                setColor(c);
            }
        }
    };

    const updateItems = async function () {
        let attributeQueries: any = {};
        for (let key in pageitemsTable.filterItems) {
            if (pageitemsTable.filterItems[key].sortFilter.sortItem.length > 0) {
                attributeQueries[key] = pageitemsTable.filterItems[key].sortFilter.sortItem[0];
            }
        }
        //console.debug(pageitemsTable);
        //console.debug(attributeQueries);

        attributeQueries.ClassName = 'Parameter';

        hmiclientbase.GetItemList('', attributeQueries).then((newitems: string[]) => {
            setIdItemsTable(newitems);

            let newOptionsPage = pageitemsTable.OptionsPage;

            let maxpage = Math.ceil(newitems.length / newOptionsPage.SizePage);

            newOptionsPage.MaxPage = maxpage;

            setpageItemsTable({
                ...pageitemsTable,
                ['OptionsPage']: newOptionsPage
            });
        });
    };

    const UpdteItemPage = function (page: number) {
        if (page > -1 && page <= pageitemsTable.OptionsPage.MaxPage - 1) {
            let pageItemCount = pageitemsTable.OptionsPage.SizePage;
            let newitems = iditemsTable.slice(page * pageItemCount, page * pageItemCount + pageItemCount - 1);

            // console.log("newitems", newitems.length);

            let params = hmiclientbase.GetParamsItems(newitems);

            //console.log(params.length);
            // console.log(params[1]);

            let newOptionsPage = pageitemsTable.OptionsPage;
            newOptionsPage.SelectPage = page;

            setpageItemsTable({
                ...pageitemsTable,
                ['items']: params,
                ['OptionsPage']: newOptionsPage
            });
        } else if (page == 0) {
            let newOptionsPage = pageitemsTable.OptionsPage;
            newOptionsPage.SelectPage = page;

            setpageItemsTable({
                ...pageitemsTable,
                ['items']: [],
                ['OptionsPage']: newOptionsPage
            });
        }
    };

    const handleClickSave = () => {
        let hex = RGBAToHex(color);
        if (namePoint !== '') {
            props.callbackSave(props.id, namePoint, typeLine, typeScale, hex);
        }
    };

    const handleClickSetNamePoint = (param: string) => {
        setNamePoint(param);
        setOpenEditPath(false);
    };
    const handleClickCloseNamePoint = () => {
        setOpenEditPath(false);
    };

    const handleClose = () => {
        props.callbackSave(-1, '', '');
    };

    const handleOld = () => {
        setItem('');
    };

    let KeySearch = function (e: any) {
        if (e.key == 'Enter') {
            let val = e.target.value.toUpperCase();
            let listtemp = window.parent.GetItemList();
            let newlistitem: string[] = [];
            for (let i = listtemp.length; i--; ) {
                if (listtemp[i].toUpperCase().indexOf(val) != -1) {
                    newlistitem.unshift(listtemp[i]);
                }
            }
            setListItem(newlistitem);
        }
    };

    if (!openEditPath) {
        let typeLineCount = -1;
        let typeScaleCount = -1;
        return (
            <div>
                <Dialog
                    fullScreen={fullScreen}
                    open={open}
                    //onClose={() => { }}
                    aria-labelledby="responsive-dialog-title"
                    style={{ fontSize: '12px' }}>
                    <DialogContent>
                        <div style={{ display: 'flex', alignItems: 'center', padding: '5px 20px' }}>
                            <div style={{ paddingRight: '1em' }}>Цвет:</div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    height: '150px',
                                    flexDirection: 'column'
                                }}>
                                <CompactPicker
                                    color={color}
                                    onChange={(color) => {
                                        setColor(color.rgb);
                                    }}
                                />
                                <AlphaPicker
                                    width={'245px'}
                                    color={color}
                                    onChange={(color) => {
                                        setColor(color.rgb);
                                    }}
                                />
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <TextField
                                        id="color"
                                        style={{ minWidth: '20em', fontSize: '12px' }}
                                        value={colorText}
                                        size="small"
                                        onChange={(event: React.ChangeEvent<{ value: any }>) =>
                                            parseColorStr(event.target.value)
                                        }
                                        onFocus={() => {
                                            setColorTextFocus(true);
                                        }}
                                        onBlur={() => {
                                            setColorTextFocus(false);
                                        }}
                                    />
                                    <div
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setColorOutType(colorOutType !== 'HEX' ? 'HEX' : 'RGBA');
                                        }}>
                                        {colorOutType}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', padding: '5px 20px' }}>
                            <div style={{ paddingRight: '1em' }}>Точка:</div>
                            <TextField
                                id="name"
                                size="small"
                                style={{ minWidth: '20em', fontSize: '12px' }}
                                value={namePoint}
                                onChange={(event: React.ChangeEvent<{ value: any }>) =>
                                    setNamePoint(event.target.value)
                                }
                            />
                            <EditOutlined
                                fontSize="small"
                                onClick={() => {
                                    setOpenEditPath(true);
                                }}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', padding: '5px 20px' }}>
                            <div style={{ paddingRight: '1em' }}>Линия: </div>
                            <Select
                                value={typeLine}
                                onChange={(event: SelectChangeEvent) => {
                                    setTypeLine(event.target.value);
                                }}
                                inputProps={{
                                    id: 'max-width'
                                }}
                                style={{ minWidth: '10em', fontSize: '12px' }}
                                size="small">
                                {typeLineArr?.map((str: any, index: number) => {
                                    typeLineCount++;
                                    return (
                                        <MenuItem key={index} value={str}>
                                            {typeLineArrRus[typeLineCount]}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', padding: '5px 20px' }}>
                            <div style={{ paddingRight: '1em' }}>Масштаб: </div>
                            <Select
                                value={typeScale}
                                onChange={(event: SelectChangeEvent) => setTypeScale(event.target.value)}
                                inputProps={{
                                    id: 'max-width'
                                }}
                                style={{ minWidth: '10em', fontSize: '12px' }}
                                size="small">
                                {typeScaleArr?.map((str: any, index: number) => {
                                    typeScaleCount++;
                                    return (
                                        <MenuItem key={index} value={str}>
                                            {typeScaleArrRus[typeScaleCount]}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClickSave} color="primary">
                            Сохранить
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            Отмена
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    let PrevPage = () => {
        UpdteItemPage(pageitemsTable.OptionsPage.SelectPage - 1);
    };

    let NextPage = () => {
        UpdteItemPage(pageitemsTable.OptionsPage.SelectPage + 1);
    };

    let ButtonLeft = () => {
        return (
            <button
                style={{
                    order: 1,
                    padding: 0,
                    minWidth: 0,
                    width: '40px',
                    height: '40px',
                    flexShrink: 0,
                    lineHeight: '40px',
                    borderRadius: '50%',
                    border: 'none',
                    background: '#fff',
                    cursor: pageitemsTable.OptionsPage.SelectPage == 0 ? 'default' : 'pointer'
                }}
                type="button"
                onClick={() => {
                    PrevPage();
                }}>
                <span>
                    <svg
                        focusable="false"
                        viewBox="0 0 24 24"
                        style={{ fill: pageitemsTable.OptionsPage.SelectPage == 0 ? '#bbb' : '#000' }}>
                        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                    </svg>
                </span>
            </button>
        );
    };

    let SelectItems = function (items: string[], index: number, count: number) {
        if (count != 0) {
            let TempItems = pageitemsTable.items[index];
            /*
            for (let key in TempItems) {
                console.debug(key + " " + TempItems[key]);
            }
            //setItemSelected(index);
            */
            setNamePoint(TempItems.path + '.CV');
            setOpenEditPath(false);
        } else {
            setItemSelected(-1);
        }
    };

    let ViewSettingItem = () => {
        if (ItemSelectedIndex != -1) {
            let viewTR = [];

            let TempItems = pageitemsTable.items[ItemSelectedIndex];
            for (let key in TempItems) {
                //console.debug(key + " " + TempItems[key]);
                viewTR.push(
                    <tr className={'Alarms__table_tr'}>
                        <td className={'Alarms__table_td'}>{key}</td>
                    </tr>
                );
            }

            return (
                <table className={'Alarms__table'} style={{ border: 'solid', width: '150px' }}>
                    <tr className={'Alarms__table_tr'}>
                        <th className={'Alarms__table_th'}>Свойство</th>
                    </tr>
                    {viewTR}
                </table>
            );
        } else return <div></div>;
    };

    let selectFindItem = function (item: string, value: string, key: string) {
        //console.debug(item + " " + value + " " + key);

        if (value == 'default') {
            value = '';
        } else if (value == 'alfabet') {
            value = '';
            return;
        }
        let TempItemsTable = pageitemsTable;
        if (TempItemsTable.filterItems[item].sortFilter.sortItem.length > 0)
            TempItemsTable.filterItems[item].sortFilter.sortItem[0] = value;
        else TempItemsTable.filterItems[item].sortFilter.sortItem.push(value);
        setpageItemsTable(TempItemsTable);
    };

    let OnClikcFilter = function (nameButton: string) {
        //console.debug(nameButton);
        updateItems();
        console.log('ssss');
    };

    let ButtonRight = () => {
        return (
            <button
                style={{
                    order: 3,
                    padding: 0,
                    minWidth: 0,
                    width: '40px',
                    height: '40px',
                    flexShrink: 0,
                    lineHeight: '40px',
                    borderRadius: '50%',
                    border: 'none',
                    background: '#fff',
                    cursor:
                        pageitemsTable.OptionsPage.SelectPage >= pageitemsTable.OptionsPage.MaxPage - 1
                            ? 'default'
                            : 'pointer'
                }}
                type="button"
                onClick={() => {
                    NextPage();
                }}>
                <span>
                    <svg
                        focusable="false"
                        viewBox="0 0 24 24"
                        style={{
                            fill:
                                pageitemsTable.OptionsPage.SelectPage >= pageitemsTable.OptionsPage.MaxPage - 1
                                    ? '#bbb'
                                    : '#000'
                        }}>
                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                    </svg>
                </span>
            </button>
        );
    };

    if (item != '') {
        return (
            <div>
                <Dialog
                    fullScreen={fullScreen}
                    open={open}
                    onClose={handleClickCloseNamePoint}
                    aria-labelledby="responsive-dialog-title">
                    <DialogTitle id="responsive-dialog-title">
                        {'Выберите параметр '} <div> {item + ':'} </div>{' '}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {window.parent.GetParamsItem(item)?.map((str: any) => (
                                <li
                                    key={str}
                                    className={'listitem'}
                                    onClick={() => handleClickSetNamePoint(item + '.' + str.toUpperCase())}>
                                    {str}
                                </li>
                            ))}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleOld} color="primary">
                            Назад
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
    //else if (typeLine == '') {
    //    let typeLineCount = -1;
    //    return (
    //        <div>
    //            <Dialog
    //                fullScreen={fullScreen}
    //                open={open}
    //                onClose={handleClose}
    //                aria-labelledby="responsive-dialog-title"
    //            >
    //                <DialogTitle id="responsive-dialog-title">{"Выберите тип линии "}</DialogTitle>
    //                <DialogContent>
    //                    <DialogContentText>
    //                        {typeLineArr.map((str: any) => {
    //                            typeLineCount++;
    //                            return (
    //                                <li key={str} className={"listitem"} onClick={() => setTypeLine(str)}>{typeLineArrRus[typeLineCount]}</li>
    //                            )
    //                        }
    //                        )}
    //                    </DialogContentText>
    //                </DialogContent>
    //                <DialogActions>
    //                    <Button onClick={handleClose} color="primary">
    //                        Отмена
    //      </Button>

    //                </DialogActions>
    //            </Dialog>
    //        </div>
    //    );
    //}
    else {
        return (
            <div>
                <Dialog
                    fullScreen={fullScreen}
                    open={open}
                    onClose={handleClickCloseNamePoint}
                    aria-labelledby="responsive-dialog-title"
                    PaperProps={{ style: { maxHeight: '90%' } }}>
                    <DialogTitle id="responsive-dialog-title"></DialogTitle>
                    <DialogContent>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                height: '70vh'
                            }}>
                            <div style={{ overflowX: 'auto', position: 'relative', border: 'solid' }}>
                                <Tabel
                                    reports={pageitemsTable.items}
                                    colList={pageitemsTable.colList}
                                    filterItems={pageitemsTable.filterItems}
                                    minWindth={500}
                                    selectedOne={true}
                                    IDCol={'path'}
                                    selectFindItem={(item: string, value: string, key: string) =>
                                        selectFindItem(item, value, key)
                                    }
                                    OnClikcFilter={(nameButton: string) => OnClikcFilter(nameButton)}
                                    SelectedItem={(ItemsSelect: string[], index: number, CountItem: number) => {
                                        SelectItems(ItemsSelect, index, CountItem);
                                    }}
                                />
                            </div>
                            {/*ViewSettingItem()*/}
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                minHeight: '56px',
                                padding: '0 8px',
                                flexWrap: 'wrap-reverse',
                                width: '100%'
                            }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ order: 2, fontSize: '1rem', margin: '0' }}>
                                    Страница {pageitemsTable.OptionsPage.SelectPage + 1}
                                </div>
                                {ButtonLeft()}
                                {ButtonRight()}
                            </div>
                        </div>
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'none',
                                position: 'absolute',
                                top: '0',
                                background: '#fff',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                            <img src="../static/images/loading_hend.gif" />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setOpenEditPath(false);
                            }}
                            color="primary">
                            Назад
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
};

export default DialogParams;
